import script from "./agent.vue?vue&type=script&setup=true&lang=js"
export * from "./agent.vue?vue&type=script&setup=true&lang=js"

import "./agent.vue?vue&type=style&index=0&id=31ce8fb2&lang=scss"

const __exports__ = script;

export default __exports__